import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendEmailVerification, reload } from 'firebase/auth';
import { useAuth } from '../contexts/AuthContext';

export default function VerifyEmail() {
  const { currentUser } = useAuth();
  const [message,setMessage]=useState('');
  const [busy,setBusy]=useState(false);
  const [verified,setVerified]=useState(currentUser?.emailVerified || false);
  const send=async()=>{
    setBusy(true);setMessage('');
    try {await sendEmailVerification(currentUser);setMessage('Verification email sent. Check your inbox and spam folder.');}
    catch(e){setMessage(e.code==='auth/too-many-requests'?'Please wait before requesting another email.':(e.message||'Could not send verification email.'));}
    finally{setBusy(false);}
  };
  const check=async()=>{
    setBusy(true);
    try {await reload(currentUser);setVerified(currentUser.emailVerified);setMessage(currentUser.emailVerified?'Email verified. You can return to your dashboard.':'Not verified yet. Open the email and click its verification link.');}
    catch(e){setMessage(e.message||'Could not check status.');}
    finally{setBusy(false);}
  };
  if(!currentUser) return <main className="mx-auto max-w-lg p-8"><p>Please log in first.</p><Link className="text-blue-700 underline" to="/login">Log in</Link></main>;
  return <main className="mx-auto max-w-lg px-4 py-16 text-slate-900">
    <section className="rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
      <h1 className="text-2xl font-bold">Verify your email</h1>
      <p className="mt-3 text-slate-600">To link an existing Chuko Logic quote request to your portal account, confirm that you own <strong>{currentUser.email}</strong>.</p>
      {(verified || currentUser.emailVerified) ? <p className="mt-5 rounded-lg bg-green-50 p-4 font-semibold text-green-800">Your email is verified.</p> :
      <div className="mt-6 flex flex-col gap-3">
        <button disabled={busy} onClick={send} className="rounded-lg bg-blue-700 px-5 py-3 font-semibold text-white disabled:opacity-50">Send verification email</button>
        <button disabled={busy} onClick={check} className="rounded-lg border border-slate-300 px-5 py-3 font-semibold disabled:opacity-50">I've verified — check again</button>
      </div>}
      {message && <p role="status" className="mt-4 text-sm text-slate-700">{message}</p>}
      <Link className="mt-6 inline-block text-blue-700 underline" to="/dashboard">Back to dashboard</Link>
    </section>
  </main>;
}
